import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector} from 'react-redux';
import { FiEdit, FiDelete } from 'react-icons/fi';
import {Link} from 'react-router-dom';
import { deleteABlogCat, getCategories, resetState } from '../features/bcategory/bcategorySlice';
import CustomModal from '../components/CustomModal';

const columns = [
  {
    title: 'No',
    dataIndex: 'key',
  },
  {
    title: 'Name',
    dataIndex: 'name',
  },
  {
    title: 'Action',
    dataIndex: 'action',
  },
];
 

const Blogcatlist = () => {
  const [open, setOpen] = useState(false);
  const [bcatId, setbcatId] = useState('');
  const showModal = (e) => {
    setOpen(true);
    setbcatId(e);
  };
  const hideModal = () => {
    setOpen(false);
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getCategories());
  }, []);
  const bCatState = useSelector((state) => state.bCategory.bCategories);
  const data1 = [];
  for (let i = 0; i < bCatState.length; i++) {
    data1.push({
      key: i + 1,
      name: bCatState[i].title,
      action: <><Link to={`/admin/blog-category/${bCatState[i]._id}`}><FiEdit /></Link><button onClick={() => showModal(bCatState[i]._id)} className='ms-3 text-danger bg-transparent border-0'><FiDelete /></button></>,
    });
  }
  const deleteBlogCategory = (e) => {
    setOpen(false);
    dispatch(deleteABlogCat(e));
    setTimeout(() => {
      dispatch(getCategories());
    },100);
  };
  return (
    <div>
      <h3 className='mb-4'>Blog Categories</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal hideModal={hideModal} open={open} title='Are you sure to delete it?' action={() => {deleteBlogCategory(bcatId)}} />
    </div>
  )
}

export default Blogcatlist
